export function removeChildren(container: Element | null) {
  if (container) {
    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }
  }
}

export function moveChildren(source: Element | null, target: Element | null) {
  target?.append(...(source?.children ?? []));
}

/**
 * Un-entities a string (e.g. converts &amp; to &)
 */
export function unEntity(str: string): string {
  return str.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
}
